import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-service',
  imports: [],
  templateUrl: './terms-of-service.html',
})
export class TermsOfService {}
